export const SET_PA_SEARCH_COMPLETE = 'setPASearchResults';
export const SET_PA_SEARCH_BUSY = 'setPASearchBusy';
export const SET_PA_EXPORT_BUSY = 'setPAExportBusy';
export const SAVE_PA_EXPORT_FIELDS = 'savePAExportFields';
export const SET_PA_SEARCH_METRICS_COMPLETE = 'setPASearchMetricsResults';



// WEBPACK FOOTER //
// ./src/store/pa/mutations.type.js